// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"iK-z","carouselContainer":"jK-z"};